// Shared helpers for the two path-search UIs (landing PathSearchPanel and the
// graph-canvas popover). /explore/search returns each entity's Neo4j id and
// label; the legacy map only covers older servers that don't send them.
import type { ExploreSearchResult } from '../../lib/exploreApi';

const LEGACY_CATEGORY_LABEL: Record<string, string> = {
  actor: 'ThreatActor',
  family: 'MalwareFamily',
  cve: 'CVE',
  technique: 'AttackTechnique',
  ioc: 'IOC',
};

export const PATH_CATEGORY_DISPLAY: Record<string, string> = {
  actor: 'Actor', family: 'Family', ioc: 'IOC', cve: 'CVE', technique: 'Technique',
};

/** Neo4j label of a search result. Every non-intel category key (ip, domain,
 *  crypto.btc, mitre.group, …) is an IOC registry category. */
export function pathLabel(r: ExploreSearchResult): string {
  return r.label || LEGACY_CATEGORY_LABEL[r.category] || 'IOC';
}

/** Countries connect only via ATTRIBUTED_TO, which is not a path edge type. */
export const PATH_EXCLUDED_CATEGORIES = ['country'];

export function isPathEndpoint(r: ExploreSearchResult): boolean {
  return !PATH_EXCLUDED_CATEGORIES.includes(r.category);
}
